exports.onClientEntry = (_, pluginOptions) => {
  window.oneTrustDomainList = pluginOptions.domainList;
};
